<section class="cron-editor-main">
  <mat-tab-group #tabGroup
                 class="cron-editor-container"
                 [(selectedIndex)]="tabIndex"
                 (selectedTabChange)="onTabFocus($event)"
                 [color]="color">

    <!-- Minute -->
    <mat-tab class="cron-editor-tab"
             label="Minutes">
      <div class="cron-editor-tab-content">

        <span class="cron-form-label">Every </span>

        <cron-time-picker [formGroup]="minutesForm"
                          [use24HourTime]="options.use24HourTime"
                          [hideHours]="true"
                          [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz"
                          [minutesStartFrom]="1">
        </cron-time-picker>
      </div>
    </mat-tab>

    <!-- Hourly -->
    <mat-tab class="cron-editor-tab"
             label="Hourly">
      <div class="cron-editor-tab-content">
        <span class="cron-form-label">Every </span>

        <cron-time-picker [formGroup]="hourlyForm"
                          [use24HourTime]="options.use24HourTime"
                          [hideSeconds]="options.hideSeconds ||  !isCronFlavorQuartz">
        </cron-time-picker>
      </div>
    </mat-tab>


    <!-- Daily-->
    <mat-tab class="cron-editor-tab"
             label="Daily">
      <div class="cron-editor-tab-content"
           [formGroup]="dailyForm">
        <span class="cron-form-label">Every </span>

        <mat-label>Day(s)</mat-label>
        <mat-select>
          <mat-option *ngFor="let monthDay of selectOptions.monthDays"
                      [value]="monthDay">
            {{monthDay}}
          </mat-option>
        </mat-select>

        at

        <cron-time-picker [use24HourTime]="options.use24HourTime"
                          [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
        </cron-time-picker>

      </div>
    </mat-tab>

    <!-- Weekly-->
    <mat-tab class="cron-editor-tab"
             label="Weekly">
      <div class="cron-editor-tab-content">

        <span class="cron-form-label">Every </span>

        <div [formGroup]="weeklyForm">
          <mat-checkbox class="checkbox-margin"
                        formControlName="MON">Monday</mat-checkbox>
          <mat-checkbox class="checkbox-margin"
                        formControlName="TUE">Tuesday</mat-checkbox>
          <mat-checkbox class="checkbox-margin"
                        formControlName="WED">Wednesday</mat-checkbox>
          <mat-checkbox class="checkbox-margin"
                        formControlName="THU">Thursday</mat-checkbox>
          <mat-checkbox class="checkbox-margin"
                        formControlName="FRI">Friday</mat-checkbox>
          <mat-checkbox class="checkbox-margin"
                        formControlName="SAT">Saturday</mat-checkbox>
          <mat-checkbox class="checkbox-margin"
                        formControlName="SUN">Sunday</mat-checkbox>
        </div>


        <span class="cron-form-label">at time </span>

        <cron-time-picker [formGroup]="weeklyForm"
                          [use24HourTime]="options.use24HourTime"
                          [hideSeconds]="options.hideSeconds|| !isCronFlavorQuartz">
        </cron-time-picker>
      </div>

    </mat-tab>

    <!-- Advanced-->
    <mat-tab class="cron-editor-tab"
             label="Advanced">
      <div class="cron-editor-tab-content"
           [formGroup]="advancedForm">

        <mat-form-field>
          <mat-label>Expression (UTC TimeZone)</mat-label>
          <input matInput
                 type="text"
                 class="advanced-cron-editor-input"
                 formControlName="expression">
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>